<template>
  <a-tree-select :class="klass"
    :dropdownStyle="dropdownStyle"
    :treeData="list"
    :placeholder="placeholder"
    treeDefaultExpandAll
    :value="value"
    @change="value => onChange(value)">
  </a-tree-select>

</template>

<script>

import eBase from '@/base/eBase.js'
import _ from 'underscore'

export default {

  props: {
    url:{required:true},
    options:{required:true},
    method:{required:false,default:'get'},
    klass:{required:false,default:'full-input'},
    dropdownStyle:{required:false,default:function() {return { maxHeight: '400px', overflow: 'auto' };}},
    placeholder:{required:false,default:'请选择'},
    value:{required:false,default:function() {return [];}},
    disabled:{required:false,default:false},
    selectFirst:{required:false,default:false},
  },

  data() {
    return {
      list:[],
    }
  },

  created() {
    eBase.debug('[DynamicTreeSelect.vue][created][enter]');
    this.init();
  },

  mounted() {
    eBase.debug('[DynamicTreeSelect.vue][mounted][enter]');
  },

  watch:{
    options:{
      handler(newValue,oldValue) {
      },
      immediate:false
    }
  },

  computed:{
  },

  methods:{

    init () {
      this.search()
    },

    search() {
      const self = this;
      eBase.send({url:this.url,params:this.options},this.method).then((res) => {
        self.list = res.data.list || res.data.data || [{label:'根',value:'0',key:'0',children:self.compilerRows(res.data.restluLis)}];
        self.list.length > 0 && self.selectFirst && self.$emit('onSelectFirst',self.list[0].key);
        self.$emit('selectRenderComplete',self.list);
      });
    },

    onChange (value) {
      this.$emit('change',value);
    },

    compilerRows (arr) {
      var self = this;
      var result = [];
      arr.forEach(function(item){
        const newItem =  {label:item.name + '',value:item.id + '',key:item.id + ''};
        if(item.hasOwnProperty('children') && item.children && _.isArray(item.children) ) {
          newItem.children = self.compilerRows(item.children.map(one => ({ ...one })));
        }
        result.push(newItem);
      });

      return result;
    },

  },// EOF methods
}
</script>



// WEBPACK FOOTER //
// src/components/select/DynamicTreeSelect.vue